<template>
    <div>
        <div v-if="userForm.cat_profile_id >= 4"><br><br><br><br><br><br></div>
        <div class="el-row--flex" v-if="userForm.cat_profile_id >= 3">
            <div class="el-col el-col-12">
                <h2>Mi Perfil</h2>
                <hr class="red">
            </div>
            <div class="el-col el-col-12">
                <div align="right" style="width: 70%; padding-left: 100px; margin-top: 100px">
                    <button type="button" @click="$router.push('/solicitudes')"
                            class="list-group-item list-group-item-action">Regresar
                    </button>
                </div>
            </div>
        </div>
        <HeaderSection icon="fa-user" title="Perfil" v-if="userForm.cat_profile_id <= 3 && !updateInfo">
            <template slot="buttons">
                <el-button
                    size="medium"
                    type="danger"
                    icon="el-icon-arrow-left"
                    @click="$router.push('/')">
                    Regresar
                </el-button>
            </template>
        </HeaderSection>
        <br>
        <div>
            <el-form ref="user-form" :model="userForm" label-width="120px" label-position="top">
                <el-row :gutter="20">
                    <el-col :span="8" v-if="updateInfo">
                        <el-form-item
                            label="Tipo de usuario"
                            prop="isLdap"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-switch
                                v-model="userForm.isLdap"
                                active-text="Interno/Cancillería"
                                inactive-color="#13322B"
                                active-color="#9d2438"
                                inactive-text="Externo">
                            </el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item
                            label="Usuario"
                            prop="username"
                            :rules="[
                                 { required: true, message: 'Este campo es obligatorio', trigger: 'change' },
                                 { pattern:/^[ña-z-ú_]+?$/, message: 'Ingrese sólo letras minúsculas' }
                                ]">
                            <el-input v-model="userForm.username"
                                      :disabled="!userInfo.isMigrate">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item
                            label="Correo electrónico"
                            prop="email"
                            :rules="[{ required: true, message: 'Este campo es obligatorio', trigger: 'blur' },
                                { type: 'email', message: 'Introduzca un correo valido', trigger: 'blur' },
                                { max: 70, message: 'Este campo debería ser de máximo 70 caracteres', trigger: 'blur' }]">
                            <el-input v-my-only-alphanumeric="{maxChars: 70}"
                                      :disabled="userForm.isLdap && userInfo.isMigrate"
                                      v-model="userForm.email"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20" v-if="userInfo.isMigrate && userForm.isLdap && !hidePassword">
                    <el-col :span="12">
                        <el-form-item
                            label="Contraseña correo institucional"
                            prop="password"
                            :rules="[{ required: true, message: 'Este campo es obligatorio', trigger: 'blur' }]">
                            <el-input
                                show-password
                                @change="checkUser(userForm)"
                                v-model="userForm.password"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item
                            label="Apellido Paterno"
                            prop="firstName"
                            :rules="[{ required: true, message: 'Este campo es obligatorio', trigger: 'blur' },
                                    { max: 70, message: 'Este campo debería ser de máximo 70 caracteres', trigger: 'blur' },
                                    {pattern:/^[ña-zÀ-úÑA-Z0-9 _]+?$/,message: 'Ingrese sólo letras y/o números'}]">

                            <el-input v-my-only-alphanumeric="{maxChars: 70}"
                                      :disabled="userForm.isLdap && userInfo.isMigrate"
                                      v-model="userForm.firstName"
                                      class="input-with-select">
                                <el-select class="el-select-custom"
                                           v-model="userForm.cat_user_prefix_id"
                                           slot="prepend"
                                           placeholder="tít.">
                                    <el-option
                                        v-for="prefix in prefixes"
                                        :key="prefix.id"
                                        :label="prefix.name"
                                        :value="prefix.id">
                                    </el-option>
                                </el-select>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="Apellido Materno"
                                      :rules="{pattern:/^[ña-zÀ-úÑA-Z0-9 _]+?$/,message: 'Ingrese sólo letras y/o números'}">
                            <el-input v-my-only-alphanumeric="{maxChars: 70}"
                                      :disabled="userForm.isLdap && userInfo.isMigrate"
                                      v-model="userForm.secondName"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item
                            label="Nombre(s)"
                            prop="name"
                            :rules="[{ required: true, message: 'Este campo es obligatorio', trigger: 'blur' },
                                    { max: 70, message: 'Este campo debería ser de máximo 70 caracteres', trigger: 'blur' },
                                    {pattern:/^[ña-zÀ-úÑA-Z0-9 _]+?$/,message: 'Ingrese sólo letras y/o números'}]">

                            <el-input v-my-only-alphanumeric="{maxChars: 70}"
                                      :disabled="userForm.isLdap && userInfo.isMigrate"
                                      v-model="userForm.name"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item
                            label="Oficina"
                            prop="cat_office_id"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-select
                                v-model="userForm.cat_office_id"
                                filterable
                                clearable
                                placeholder="Seleccionar"
                                style="width: 100% !important;">
                                <el-option
                                    v-for="office in offices"
                                    :key="office.id"
                                    :label="office.name"
                                    :value="office.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="Perfil"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }"
                            prop="cat_profile_id">
                            <el-select
                                @change="userForm.changeProfile = true"
                                v-model="userForm.cat_profile_id"
                                filterable
                                placeholder="Seleccionar"
                                style="width: 100%">
                                <el-option
                                    v-for="profile in profiles"
                                    :key="profile.id"
                                    :label="profile.name"
                                    :value="profile.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="24" v-if="userForm.cat_profile_id == 5">
                        <el-form-item label="Banco"
                                      prop="cat_bank_id"
                                      :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-select
                                v-model="userForm.cat_bank_id"
                                filterable
                                :disabled="userForm.isLdap && userInfo.isMigrate"
                                placeholder="Seleccionar"
                                style="width: 100%">
                                <el-option
                                    v-for="bank in banks"
                                    :key="bank.id"
                                    :label="bank.name"
                                    :value="bank.id">
                                </el-option>
                            </el-select>
                        </el-form-item>

                    </el-col>
                    <el-col :span="24" v-if="userForm.cat_profile_id == 6">
                        <el-form-item label="No. de Corredor Público"
                                      prop="publicHallNumber"
                                      :rules="[{ required: true, message: 'Este campo es obligatorio', trigger: 'blur' },
                                    { max: 70, message: 'Este campo debería ser de máximo 70 caracteres', trigger: 'blur' },
                                    {pattern:/^[ña-zÀ-úÑA-Z0-9 _]+?$/,message: 'Ingrese sólo letras y/o números'}]">
                            <el-input v-my-only-alphanumeric="{maxChars: 70}" v-model="userForm.publicHallNumber"/>
                        </el-form-item>

                    </el-col>
                    <el-col :span="24" v-if="userForm.cat_profile_id == 7">
                        <el-form-item label="Notaria"
                                      prop="cat_notary_id"
                                      :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-select
                                v-model="userForm.cat_notary_id"
                                filterable
                                placeholder="Seleccionar"
                                style="width: 100%">
                                <el-option
                                    v-for="notary in notaries"
                                    :key="notary.id"
                                    :label="notary.name && notary.state && notary.state.name ?
                                    notary.name +' '+notary.state.name : notary.name"
                                    :value="notary.id">
                                </el-option>
                            </el-select>
                        </el-form-item>

                    </el-col>
                </el-row>
                <el-row :gutter="20" v-if="!userForm.isLdap">
                    <el-col :span="12">
                        <el-form-item
                            label="Contraseña actual"
                            prop="currentPassword"
                            :rules="[
                        {
                          required: true,
                          message: 'Escriba una contraseña', trigger: 'change'
                        },

                      ]">
                            <el-input
                                v-my-only-alphanumeric="{maxChars: 70}"
                                show-password
                                v-model="userForm.currentPassword"
                                type="password">
                            </el-input>
                        </el-form-item>

                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="Cambiar Contraseña"
                            prop="passwordConfirm"
                            :rules="{ required: false, message: 'Este campo es obligatorio', trigger: 'blur' }">
                            <el-switch
                                v-model="userForm.changePassword"
                                inactive-color="#13322B"
                                active-color="#9d2438">
                            </el-switch>
                        </el-form-item>

                    </el-col>
                </el-row>
                <el-row v-if="userForm.changePassword" :gutter="20">
                    <el-col :span="12">
                        <el-form-item
                            label="Nueva Contraseña"
                            prop="password"
                            :rules="[
                        {
                          required: true,
                          message: 'Escriba una contraseña', trigger: 'change'
                        },
                        {
                          min: 12,
                          message: 'Escriba al menos 12 caracteres', trigger: 'change'
                        },
                        {
                          pattern: '.*[0-9].*',
                          message: 'Indique al menos un número', trigger: 'change'
                        },
                        {
                          pattern: '.*[a-z]',
                          message: 'Indique al menos una minuscula', trigger: 'change'
                        },
                        {
                          pattern: '.*[A-Z]',
                          message: 'Indique al menos una mayúscula', trigger: 'change'
                        },
                        {
                          pattern: '.*[¡!@#$%^&*(),.¿?:{}|<>]',
                          message: 'Indique al menos un carácter especial', trigger: 'change'
                        }
                      ]">
                            <password style="background-color: #ffffff !important;"
                                      :toggle="true"
                                      :badge="false"
                                      v-model="userForm.password"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="Confirmar Contraseña"
                            prop="passwordConfirm"
                            :rules="[
                        {
                          required: true,
                          message: 'Escriba una contraseña', trigger: 'change'
                        },
                        {
                          min: 12,
                          message: 'Escriba al menos 12 caracteres', trigger: 'change'
                        },
                        {
                          pattern: '.*[0-9].*',
                          message: 'Indique al menos un número', trigger: 'change'
                        },
                        {
                          pattern: '.*[a-z]',
                          message: 'Indique al menos una minuscula', trigger: 'change'
                        },
                        {
                          pattern: '.*[A-Z]',
                          message: 'Indique al menos una mayúscula', trigger: 'change'
                        },
                        {
                          pattern: '.*[¡!@#$%^&*(),.¿?:{}|<>]',
                          message: 'Indique al menos un carácter especial', trigger: 'change'
                        }
                      ]">
                            <el-input
                                @change="checkPassword(userForm.password, userForm.passwordConfirm)"
                                v-model="userForm.passwordConfirm"
                                show-password>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <br>
                <el-row class="custom-header" type="flex" justify="space-between">
                    <el-col>
                        <h3 class="custom-title">
                            <i class="fas fa-lock"></i>
                            Anexos
                        </h3>
                    </el-col>
                </el-row>
                <br>
                <el-row :gutter="20">
                    <el-col :span="8" v-if="userInfo.cat_profile_id >= 4">
                        <a href=""
                           style="text-decoration: none"
                           @click.prevent="openPermission('Documentación', 3)">
                            <el-card style="background: #898989; color: whitesmoke; text-align: center">
                                Documentación
                            </el-card>
                        </a>
                    </el-col>
                    <el-col :span="8">
                        <a href=""
                           style="text-decoration: none"
                           @click.prevent="userRequest.modal = true">
                            <el-card style="background: #ea6a6a; color: whitesmoke; text-align: center">
                                e.Firma
                            </el-card>
                        </a>
                    </el-col>
                </el-row>
                <br>
                <el-row :gutter="20">
                    <el-col :span="24" align="end">
                        <el-button
                            size="medium"
                            class="btn btn-success"
                            icon="el-icon-arrow-left"
                            @click="userForm.cat_profile_id <= 3 ? $router.push('/') :$router.push('/solicitudes')">
                            Cancelar
                        </el-button>
                        <el-button
                            class="btn btn-danger"
                            size="medium"
                            icon="far fa-save"
                            @click="submitForm('user-form')">
                            Actualizar
                        </el-button>
                    </el-col>
                </el-row>
            </el-form>

            <el-dialog title="e.Firma"
                       :visible.sync="userRequest.modal"
                       :show-close="true"
                       :close-on-press-escape="true">
                <e-firma></e-firma>

                <el-button
                    v-if="!userInfo"
                    class="btn btn-danger"
                    size="medium"
                    icon="far fa-save"
                    @click="userRequest.modal = false">
                    Cancelar
                </el-button>
            </el-dialog>


            <Permissions
                v-if="!userInfo.isMigrate"
                :userId="userForm.hash_id"
                :title="title"
                :showDialog="userRequest.showModal"
                :system="system"
                :userRoles="[]"
                @save-permissions="setPermissionsBy(...arguments)"
                @close-dialog="userRequest.showModal = false"/>
        </div>
        <br>

    </div>
</template>

<script>
    import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
    import password from 'vue-password-strength-meter'
    import Permissions from "../views/administration/users/partials/Permissions";
    import eFirma from "../views/administration/users/partials/eFirma";
    import HeaderSection from "./HeaderSection";

    export default {

        props: {
            updateInfo: {}
        },

        components: {
            password,
            Permissions,
            HeaderSection,
            eFirma
        },

        computed: {
            userInfo() {
                return this.$store.state.user.user;
            },
            ...mapGetters('utils', {
                userRequest: "userRequest",
            }),
        },
        data() {
            return {
                userForm: {
                    changeProfile: false
                },
                banks: [],
                notaries: [],
                prefixes: [],
                offices: [],
                profiles: [],
                title: 'Documentación',
                showPermissions: false,
                system: 3,
                modalSign: false,
                disabledChangePassword: false,
                hidePassword: false
            }
        },

        created() {
            this.userRequest.showModal = false;
            if (this.userInfo) {
                axios.get('/api/my-profile').then(response => {
                    if (response.data.success) {
                        this.userForm = this.userInfo;
                        this.profiles = response.data.profiles;
                        this.offices = response.data.offices;
                        this.prefixes = response.data.prefixes;
                        this.banks = response.data.banks;
                        this.notaries = response.data.notaries;
                    } else {
                        this.$store.dispatch('notifications/error', {msg: response.data.message}, {root: true});
                    }
                })
            }
        },

        methods: {
            checkPassword(pass, confirmPass) {

                if (pass !== confirmPass) {
                    this.$notify({
                        type: 'warning',
                        title: 'Contraseña',
                        message: 'La contraseña no coincide, intente de nuevo.'
                    });
                }
            },

            checkUser(user) {
                if (user) {
                    let data = {
                        username: user.username,
                        password: user.password,
                        hash_id: this.userInfo.hash_id,
                    };

                    axios.post('/api/user-ldap', data).then(response => {
                        if (response.data.success) {
                            this.userForm = response.data.userData;
                            this.hidePassword = true
                        } else {
                            this.$store.dispatch('notifications/warning', {msg: response.data.message}, {root: true});
                        }

                    }).catch(error => {
                        this.userForm = {};
                        this.$message({
                            type: 'error',
                            message: 'El usuario que ingresó no es válido, ya existe en el sistema o las credenciales son incorrectas.'
                        });
                    });
                } else {
                    this.$message({
                        type: 'error',
                        message: 'Ingrese un usuario válido'
                    });
                }
            },

            openPermission(title, system) {
                this.title = title;
                this.system = system;
                this.userRequest.showModal = true;
            },

            submitForm(modelForm) {
                this.$refs[modelForm].validate((valid) => {
                    if (valid) {
                        if (this.updateInfo) {
                            this.userForm.isMigrate = true;
                            this.userForm.hash_id = this.userInfo.hash_id;
                            this.userForm.newUser = true;
                        }
                        let _params = {
                            ...this.userForm
                        };

                        if(this.userForm.changeProfile){
                            this.$confirm('La administración verificará el cambio de perfil realizado. Mientras tanto sólo podra consultar sus solicitudes, ¿desea continuar?', 'Alerta', {
                                confirmButtonText: 'Continuar',
                                cancelButtonText: 'Cancelar',
                                type: 'warning'
                            }).then(() => {

                                axios.post('/api/update-my-profile', _params).then(response => {
                                    if (response.data.success) {
                                        this.$store.dispatch('notifications/ok', {msg: response.data.message}, {root: true});
                                        // this.$router.push('/');
                                        if (response.data.userData) {
                                            this.userForm = response.data.userData
                                        }
                                        location.reload();
                                    } else {
                                        this.$store.dispatch('notifications/error', {msg: response.data.message}, {root: true});
                                    }
                                }).catch(error => {
                                    this.userForm = {};
                                    this.$message({
                                        type: 'error',
                                        message: 'Error al procesar solicitud.'
                                    });
                                });
                            }).catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: 'No se registraron cambios.'
                                });
                            });
                        }else{

                            axios.post('/api/update-my-profile', _params).then(response => {
                                if (response.data.success) {
                                    this.$store.dispatch('notifications/ok', {msg: response.data.message}, {root: true});
                                    // this.$router.push('/');
                                    if (response.data.userData) {
                                        this.userForm = response.data.userData
                                    }
                                    location.reload();
                                } else {
                                    this.$store.dispatch('notifications/error', {msg: response.data.message}, {root: true});
                                }
                            }).catch(error => {
                                this.userForm = {};
                                this.$message({
                                    type: 'error',
                                    message: 'Error al procesar su solicitud.'
                                });
                            });
                        }



                    } else {
                        this.$store.dispatch('notifications/warning', {msg: 'Complete los campos requeridos...'}, {root: true});
                    }
                })
            },

            setPermissionsBy() {

            }
        }
    }
</script>

<style scoped>
    @import 'https://framework-gb.cdn.gob.mx/assets/styles/main.css';
</style>
